import { render } from "./index.vue?vue&type=template&id=66733408"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=66733408&lang=less"

import exportComponent from "/Users/zhanghui/Documents/workSpace/github/coco-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__